// extracted by mini-css-extract-plugin
export default {"articleNumber":"orderRows_articleNumber__QQqMa","articleDescription":"orderRows_articleDescription__cAiZE","cell":"orderRows_cell__SXSse"};